import ChatHub from "../chatHub";

export default {
    install(Vue, options) {
        Vue.prototype.$chatHub = ChatHub;
    }
}
